module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp12_5012.557b1bfb.png";